<div class="embed">
	<iframe [src]="url" width="100%" height="100%"></iframe>
</div>